import {
  ADD_FORM_BUILDER_SUCCESS,
  DELETE_FORM_BUILDER_SUCCESS,
  GET_FORM_BUILDER,
  GET_FORM_BUILDER_FAILED,
  GET_FORM_BUILDER_LIST,
  GET_FORM_BUILDER_LIST_FAILED,
  GET_FORM_BUILDER_LIST_SUCCESS,
  GET_FORM_BUILDER_REPLY_SUCCESS,
  GET_FORM_BUILDER_SUCCESS,
  HIDE_DELETE_FORM_BUILDER_MODAL,
  OPEN_DELETE_FORM_BUILDER_MODAL,
  RESET_FORM_BUILDER,
  RESET_FORM_BUILDER_LIST,
  RESET_FORM_BUILDER_REPLY,
  UPDATE_FORM_BUILDER_FEATURE_SUCCESS,
  UPDATE_FORM_BUILDER_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
  formBuilder: null,
  formBuilderList: [],
  formBuilderReply: null,
  formBuilderLoading: false,
  listLoading: false,
  destroyed: false,
  listDestroyed: false,
}

const FormBuilder = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_FORM_BUILDER_SUCCESS:
      if (parseInt(action.payload.menu_feature) === 0) {
        return {
          ...state,
          formBuilderList: [...state.formBuilderList, action.payload],
        }
      } else {
        return {
          ...state,
          formBuilder: action.payload,
        }
      }
    case GET_FORM_BUILDER_LIST:
      return {
        ...state,
        listLoading: true,
        listDestroyed: false,
      }
    case GET_FORM_BUILDER_LIST_SUCCESS:
      return {
        ...state,
        formBuilderList: action.payload,
        listLoading: false,
      }
    case GET_FORM_BUILDER_LIST_FAILED:
      return {
        ...state,
        listLoading: false,
      }
    case DELETE_FORM_BUILDER_SUCCESS:
    case UPDATE_FORM_BUILDER_FEATURE_SUCCESS:
      return {
        ...state,
        formBuilderList: action.payload,
      }
    case UPDATE_FORM_BUILDER_SUCCESS:
      if (action.payload.length === 0) {
        return state
      } else {
        return {
          ...state,
          formBuilderList: action.payload,
        }
      }
    case GET_FORM_BUILDER:
      return {
        ...state,
        formBuilderLoading: true,
        destroyed: false,
      }
    case GET_FORM_BUILDER_FAILED:
      return {
        ...state,
        formBuilderLoading: false,
      }
    case GET_FORM_BUILDER_SUCCESS:
      return {
        ...state,
        formBuilder: action.payload,
        formBuilderLoading: false,
      }
    case RESET_FORM_BUILDER:
      return {
        ...state,
        formBuilder: null,
        destroyed: true,
        formBuilderLoading: false,
      }
    case OPEN_DELETE_FORM_BUILDER_MODAL:
      return {
        ...state,
        isDeleteFormBuilderModalOpen: true,
      }
    case HIDE_DELETE_FORM_BUILDER_MODAL:
      return {
        ...state,
        isDeleteFormBuilderModalOpen: false,
      }
    case RESET_FORM_BUILDER_LIST:
      return {
        ...state,
        formBuilderList: [],
        listDestroyed: true,
        listLoading: false,
      }
    case GET_FORM_BUILDER_REPLY_SUCCESS:
      return {
        ...state,
        formBuilderReply: action.payload,
      }
    case RESET_FORM_BUILDER_REPLY:
      return {
        ...state,
        formBuilderReply: null,
      }
    default:
      return state
  }
}

export default FormBuilder
